module.exports = ".modal-body {\n  padding: 25px !important; }\n  .modal-body h2 {\n    font-size: 22px; }\n  .modal-body .main-confirm-modal-text {\n    font-weight: 400;\n    line-height: 1.5; }\n  .modal-body .btn-space {\n    margin: 7px 7px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.scss
// module id = ./web/modern/components/common/confirm-general-modal/confirm-general-modal.component.scss
// module chunks = 0